import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./GradientWrapper.css"; // Ensure to create this CSS file

const GradientWrapper = ({ children, isDisplayFlex }) => {
  const gradientRef = useRef(null);

  // useEffect(() => {
  //   gsap.to(gradientRef.current, {
  //     duration: 100,
  //     repeat: -1,
  //     backgroundPosition: "100% 100%",
  //     ease: "none",
  //     keyframes: [
  //       {
  //         backgroundPosition: "0% 0%",
  //         backgroundImage: "linear-gradient(0deg, #121532, #9d8ba4, #070719)",
  //       },
  //       {
  //         backgroundPosition: "100% 100%",
  //         backgroundImage: "linear-gradient(0deg, #070719, #121532, #9d8ba4)",
  //       },
  //       {
  //         backgroundPosition: "0% 0%",
  //         backgroundImage: "linear-gradient(0deg, #9d8ba4, #070719, #121532)",
  //       },
  //     ],
  //   });
  // }, []);

  return (
    <div
      className="gradient"
      ref={gradientRef}
      style={{
        display: isDisplayFlex ? "flex" : "block",
      }}
    >
      {children}
    </div>
  );
};

export default GradientWrapper;
